// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-form {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem/* 16px */;\n}\n.col-span-4 {\n  grid-column: span 4 / span 4;\n}\n.col-span-2 {\n  grid-column: span 2 / span 2;\n}\n", ""]);
// Exports
module.exports = exports;
